<template>
  <va-row class="center">
    <va-column :xs="12" :md="6">
      <va-card>
        <va-loading v-if="isLoading" size="md" color="gray" :center="true" />
        <va-form :class="{dimmed: isLoading}" ref="form" :type="type" style="padding-top:50px; padding-bottom:20px">
          <va-form-item label="Email">
            <va-input icon="user" @keyup.enter.native="login" name="email" v-model="email" placeholder="Your email" :rules="[{type:'required'}]"
              show-clean />
          </va-form-item>
          <va-form-item label="Password">
            <va-input icon="key" @keyup.enter.native="login" name="password" v-model="password" placeholder="Your password" :rules="[{type:'required'}]"
              type="password" show-clean />
          </va-form-item>
          <va-form-item :label-col="4">
            <va-button type="primary" @click.native="login">Login</va-button>
          </va-form-item>
          <va-alert v-if="isError" type="danger" style="text-align: left; justify-content: left">
            <h4>Error:</h4>
            <p>{{errorMsg}}</p>

          </va-alert>
        </va-form>
      </va-card>
    </va-column>

  </va-row>

</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { store } from "../store";
export default {
  data() {
    return {
      type: "horizontal",
      email: "",
      password: ""
    };
  },
  computed: {
    user() {
      return store.getters.user;
    },
    isLoading() {
      return store.getters.loading;
    },
    errorMsg() {
      return store.getters.error.message;
    },
    isError() {
      return store.getters.error != null;
    }
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push("/");
      }
    }
  },
  methods: {
    ...mapActions(["signUserIn"]),
    login() {
      this.$refs.form.validateFields(result => {
        // console.log(this.email, this.password);
      });
      this.signUserIn({
        email: this.email,
        password: this.password
      });
    }
  }
};
</script>

<style>
.center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}

.dimmed {
  opacity: 0.15;
}
</style>